module.exports = __webpack_public_path__ + "static/media/YF69_1.de9f523e.jpg";